import { supabase } from '../lib/supabase';

export type TipoPL =
  | 'projeto_lei'
  | 'projeto_lei_complementar'
  | 'projeto_resolucao'
  | 'requerimento_legislativo'
  | 'indicacao'
  | 'mocao'
  | 'pedido_informacao'
  | 'outros';

export const TIPO_PL_LABEL: Record<TipoPL, string> = {
  projeto_lei: 'Projeto de Lei',
  projeto_lei_complementar: 'Projeto de Lei Complementar',
  projeto_resolucao: 'Projeto de Resolução',
  requerimento_legislativo: 'Requerimento Legislativo',
  indicacao: 'Indicação',
  mocao: 'Moção',
  pedido_informacao: 'Pedido de Informação',
  outros: 'Outros',
};

export const TIPOS_PL_LISTA: TipoPL[] = [
  'projeto_lei', 'projeto_lei_complementar', 'projeto_resolucao',
  'requerimento_legislativo', 'indicacao', 'mocao', 'pedido_informacao', 'outros',
];

export type Decisao = 'pendente' | 'sancionado' | 'promulgado' | 'vetado' | 'devolvido' | 'arquivado';

export const DECISAO_LABEL: Record<Decisao, string> = {
  pendente: 'Aguardando decisão',
  sancionado: 'Sancionado',
  promulgado: 'Promulgado',
  vetado: 'Vetado',
  devolvido: 'Respondido',
  arquivado: 'Arquivado',
};

export interface ResumoPL {
  pendentes: number;
  sancionados: number;
  promulgados: number;
  vetados: number;
  devolvidos: number;
  total: number;
}

export interface PLListaItem {
  id: string;
  numero_interno: string;
  numero_camara: string | null;
  tipo_pl: TipoPL | null;
  titulo: string;
  ementa: string | null;
  autor_camara: string | null;
  data_protocolo_camara: string | null;
  data_recebimento_executivo: string;
  decisao: Decisao;
  data_decisao: string | null;
  ato_oficial_numero: string | null;
  veto_motivo: string | null;
  veto_total: string | null;
  status_engine: string;
}

export interface PLDetalhe extends PLListaItem {
  corpo: string | null;
  ato_oficial_id: string | null;
  resposta_executivo: string | null;
  estabelecimento_nome: string | null;
  historico: Array<{
    tipo: string;
    titulo: string | null;
    mensagem: string | null;
    criado_em: string;
    ator_nome: string | null;
  }>;
}

export const protocolosLegislativosService = {
  async listar(estabelecimentoId: string, ano?: number, tipo?: string, decisao?: string, autor?: string, busca?: string): Promise<{
    ano: number; resumo: ResumoPL; protocolos: PLListaItem[];
  }> {
    const { data, error } = await supabase.rpc('protocolos_legislativos_listar_publicos', {
      p_estabelecimento_id: estabelecimentoId,
      p_ano: ano ?? null,
      p_tipo_pl: tipo ?? null,
      p_decisao: decisao ?? null,
      p_autor: autor ?? null,
      p_busca: busca ?? null,
    });
    if (error) throw error;
    const r = data as { ano: number; resumo: ResumoPL; protocolos: PLListaItem[] };
    return { ano: r.ano, resumo: r.resumo, protocolos: r.protocolos ?? [] };
  },

  async buscar(documentoId: string): Promise<PLDetalhe | { erro: string }> {
    const { data, error } = await supabase.rpc('protocolo_legislativo_buscar_publico', {
      p_documento_id: documentoId,
    });
    if (error) throw error;
    return data as PLDetalhe | { erro: string };
  },
};
